import { createContext } from 'react'

const def: any = null;

export const UserContext = createContext(def);